import { ConversationFilterIds, ConversationStatusFilter } from './enums';
import { getConversationFilterLabel } from '../utils/getConversationFilterLabel';

export const statusFilterOptions = [
  {
    value: ConversationStatusFilter.REVIEW,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.REVIEW
    )
  },
  {
    value: ConversationStatusFilter.MORE_TIME_REQUESTED,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.MORE_TIME_REQUESTED
    )
  },
  {
    value: ConversationStatusFilter.CREATED,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.CREATED
    )
  },
  {
    value: ConversationStatusFilter.ONGOING,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.ONGOING
    )
  },
  {
    value: ConversationStatusFilter.OPTED_OUT,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.OPTED_OUT
    )
  },
  {
    value: ConversationStatusFilter.QUEUED,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.QUEUED
    )
  },
  {
    value: ConversationStatusFilter.CLOSED,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.CLOSED
    )
  },
  {
    value: ConversationStatusFilter.NOT_DELIVERED,
    label: getConversationFilterLabel(
      ConversationFilterIds.status,
      ConversationStatusFilter.NOT_DELIVERED
    )
  }
];
